import { render, staticRenderFns } from "./ItemSubGroup.vue?vue&type=template&id=42d1ef10&"
import script from "./ItemSubGroup.vue?vue&type=script&lang=js&"
export * from "./ItemSubGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Mihai Racoreanu\\Code\\bodyswaps\\bsportal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42d1ef10')) {
      api.createRecord('42d1ef10', component.options)
    } else {
      api.reload('42d1ef10', component.options)
    }
    module.hot.accept("./ItemSubGroup.vue?vue&type=template&id=42d1ef10&", function () {
      api.rerender('42d1ef10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/ItemSubGroup.vue"
export default component.exports